import { handleActions } from 'redux-actions';
import { emptyMetaConversation } from '../../../conversation/reducers/conversation';
import { addCallerActions } from '../actions/addCaller';
const initialState = {
    meta: {
        addCallerAsync: 'succeeded',
        searchUserAsync: 'succeeded',
    },
    ui: {
        isModalShown: false,
    },
    users: [],
    metaConversation: emptyMetaConversation(),
};
const { addCallerCallRequest, addCallerCallRequestSucceeded, addCallerCallRequestFailed, addCallerGetUsersByQuery, addCallerGetUsersByQuerySucceeded, addCallerGetUsersByQueryFailed, addCallerModalOpen, addCallerModalClose, } = addCallerActions;
const addCaller = handleActions({
    [addCallerModalOpen.toString()]: (state, action) => {
        const { metaConversation } = action.payload;
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: true }), metaConversation });
    },
    [addCallerModalClose.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [] });
    },
    [addCallerGetUsersByQuery.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchUserAsync: 'loading' }) });
    },
    [addCallerGetUsersByQuerySucceeded.toString()]: (state, action) => {
        var _a;
        const { data } = action.payload;
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchUserAsync: 'succeeded' }), users: ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.hits) || [] });
    },
    [addCallerGetUsersByQueryFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchUserAsync: 'failed' }), users: [] });
    },
    [addCallerCallRequest.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { addCallerAsync: 'loading' }) });
    },
    [addCallerCallRequestSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { addCallerAsync: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [], metaConversation: emptyMetaConversation() });
    },
    [addCallerCallRequestFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { addCallerAsync: 'failed' }) });
    },
}, initialState);
export default addCaller;
